import { tss } from '@/shared/styles/tss'
import { tempAssetsExports } from '@/tempAssetsExports.ts'

export const useStyles = tss.withName('DailyCaseBanner').create(({ theme }) => ({
  root: {
    width: '90%',
    minHeight: '175px',
    position: 'relative',
    border: `2px solid ${theme.colors.borders.default}`,
    borderBottom: 'none',
    borderRadius: `${theme.sizes.radiuses.xl} ${theme.sizes.radiuses.xl} 1px 1px`,
    backgroundColor: '#2a3038',
    ':after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '35%',
      transform: 'translate(-35%, -50%)',
      width: '100px',
      height: '100px',
      background: 'rgba(22, 150, 157, 0.69)',
      filter: 'blur(40px)',
      zIndex: -1,
    },

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
  },
  caseImage: {
    backgroundImage: `url(${tempAssetsExports.dailyCase})`,
    width: '230px',
    height: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    left: 0,
  },

  timeDisplayAndTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },

  secondaryCaseImage: {
    backgroundImage: `url(${tempAssetsExports.dailyCaseBg})`,
    width: '170px',
    aspectRatio: '1/1',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    left: 0,
    top: '25px',
    zIndex: 10,
    ':before': {
      content: '""',
      position: 'absolute',
      left: '-10px',
      top: '-45px',
      zIndex: 9,
      backgroundImage: `url(${tempAssetsExports.dailyCaseShop})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      width: '110%',
      height: '110%',
    }
  },

  content: {
    alignSelf: 'start',
    zIndex: 9,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  freeCaseInText: {
    fontSize: '13px',
    fontWeight: 350,
    color: theme.colors.text.primary,
  },

  title: {
    color: theme.colors.text.primary,
    fontSize: theme.sizes.texts.fontSize.m,
    fontWeight: '550',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    span: {
      color: theme.colors.text.golden,
    },
  },
  viewRewards: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    p: {
      color: theme.colors.text.secondary,
    },
  },
  claim: {
    width: '100%',
    aspectRatio: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '24px',
    padding: '8px 16px',
    zIndex: '5',
    h1: {
      fontSize: '13px',
      margin: '0',
      textWrap: 'nowrap',
      color: `${theme.colors.background.primary} !important`,
    },
    backgroundColor: theme.colors.text.primary,
    boxShadow: '0px 0px 12px 5px rgb(17, 132, 255)!important',
  },

  progressBarWrapper: {
    zIndex: 9,
    position: 'absolute',
    bottom: '-1px',
    left: '0',
    right: '0',
    height: '4px',
    display: 'flex',
  },
}))
